import { ClickButtonSound } from '../assets/sounds';
import { MainButton } from '../assets/images';
import { classNames } from '../lib';

interface ButtonProps {
  text: string;
  onClick: () => void;
}

const Button = (props: ButtonProps) => {
  const { text, onClick } = props;
  const sound: HTMLAudioElement = new Audio(ClickButtonSound);

  const _onClick = () => {
    try {
      const isMute = localStorage.getItem('mute') || 'false';
      if (!JSON.parse(isMute)) {
        sound.load();
        sound.play();
      }
      onClick();
    } catch (e) {
      console.error('❗', e);
    }
  };

  return (
    <div
      className="relative flex justify-center items-center w-full"
      onClick={_onClick}
    >
      <div
        className={classNames([
          'h-16 w-full absolute cursor-pointer',
          'xs:h-12',
        ])}
      >
        <img className="w-full h-full" alt="main-button" src={MainButton} />
      </div>
      <span
        className={classNames([
          'z-20 text-4xl italic cursor-pointer font-bold',
          'xs:text-3xl',
        ])}
      >
        {text}
      </span>
    </div>
  );
};
export default Button;
